import { Component } from '@angular/core';

@Component({
  selector: 'app-not-found',
  template: `
    <section class="page">
      <h1>404 — Not found</h1>
      <p>That page doesn't exist.</p>
      <a routerLink="/cases">Back to cases</a>
    </section>
  `,
  styles: [`
    .page { padding: 48px; max-width: 600px; margin: 0 auto; }
    h1 { color: var(--primary); }
  `],
  standalone: false,
})
export class NotFoundComponent {}
